<template>
	<div class="section">
		<div class="section-content">
			<h1>Together, Camera Offset Project participants have saved:</h1>
			<div class="stat-container">
				<IndividualStat
				statNumber="13,237"
				statSubhead="Gallons of Gas" />
				<div class="vl"></div>
				<IndividualStat
				statNumber="273"
				statSubhead="Barrels of Oil" />
				<div class="vl"></div>
				<IndividualStat
				statNumber="14,323,500"
				statSubhead="Phone Charges" />
			</div>
		</div>
	</div>
</template>

<script>
import IndividualStat from '@/components/partials/IndividualStat';

export default {
	name: 'MathBreakdown',
	components: {
		IndividualStat,
	},
};
</script>

<style scoped lang="scss">
.section{
	width: 100%;
	display:flex;
	justify-content: center;
	@media (max-width: $screen-phone-max) {
		display: flex;
    flex-direction: column;
    align-items: center;
	}
	.section-content{
		padding:5vh;
		width:100%;
		max-width: 700px;
		padding:5vw 0px;
		@media (max-width: $screen-phone-max) {
			width:100%;
	}
	}
}

p{
	padding: 0px 0px 25px;
	font-family: $body-font;
	font-style: normal;
	font-weight: normal;
	font-size: 17px;
	line-height: 149.02%;
	text-align: center;
	@media (max-width: $screen-phone-max) {
    line-height: 120%;
	}
}

.section-header {
	color: $primary-color;
	font-family:$heading-font;
	font-size: 30px;
}

.section-subheader {
	color: $primary-color;
}

.stat-container {
	background-color: $alt-color;
	display:flex;
	justify-content: space-around;
	align-items: center;
	border-radius: 15px;
	box-shadow: 0px 10px 10px 0px rgba(0, 20, 0, 0.1);
	margin-bottom: 25px;
	@media (max-width: $screen-phone-max) {
		flex-direction: column;
		margin-left: 10vw;
    margin-right: 10vw;
	}
}

.vl {
  border-left: 1px solid $gray;
	height: 80px;
	@media (max-width: $screen-phone-max) {
		display:none;
	}
}

</style>
